/* src/app/features/habilitacao/subscricao-cotas/edicao-subscricao-cota/edicao-subscricao-cota.component.scss */
.disabled-link {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}
/*# sourceMappingURL=edicao-subscricao-cota.component.css.map */
